import { TiposAtendimentoVinculosListSearchComponent } from './TiposAtendimentoVinculosListSearchComponent'
import { TiposAtendimentoVinculosListToolbar } from './TiposAtendimentoVinculosListToolbar'

export const TiposAtendimentoVinculosListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <TiposAtendimentoVinculosListSearchComponent
        actions={<TiposAtendimentoVinculosListToolbar />}
      />
    </div>
  )
}
